import React from 'react';
import PropTypes from 'prop-types';
import { createStyles, withStyles } from '@material-ui/core';

import { Modal as ModalController, withModals } from 'ha/modules/ModalsLogic';
import Modal from 'ha/ui/next/Modal';

import { MobileFiltersModalName } from 'ha/constants/Filters';

const styles = t =>
  createStyles({
    modal: {
      height: '100%',
      backgroundColor: t.palette.grey[50],
    },
  });

const MobileFiltersModal = ({
  classes,
  handleClose,
  filtersComponent: MobileFilters,
  updateButtonText,
  priceFilterTitle,
}) => (
  <ModalController name={MobileFiltersModalName}>
    <Modal onClose={handleClose}>
      <div className={classes.modal}>
        <MobileFilters
          onClose={handleClose}
          updateButtonText={updateButtonText}
          priceFilterTitle={priceFilterTitle}
        />
      </div>
    </Modal>
  </ModalController>
);

MobileFiltersModal.propTypes = {
  classes: PropTypes.shape({
    modal: PropTypes.string.isRequired,
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
  filtersComponent: PropTypes.node.isRequired,
  updateButtonText: PropTypes.string.isRequired,
  priceFilterTitle: PropTypes.string.isRequired,
};

export default withModals({ name: MobileFiltersModalName })(
  withStyles(styles)(MobileFiltersModal),
);
